import React, { useState } from "react";
import { Popover, PopoverHeader, PopoverBody } from 'reactstrap';
import PropTypes from 'prop-types'
const EstimatesMessage = props => {
    const [isOpen, setIsOpen] = useState(false);

    
    return <span id={props.target} onClick={() => setIsOpen(!isOpen)} className={`link-style ${props.message?'':'hidden'}`}>Learn More
        <Popover
            className="estimate-message"
            toggle={() => setIsOpen(!isOpen)}
            placement="bottom"
            hideArrow={true}
            target={props.target}
            isOpen={isOpen}>
            <PopoverHeader>
                <button type="button" className="btn btn-icon-only" aria-label="close" onClick={() => setIsOpen(!isOpen)}><span className="icon-close" /></button>
            </PopoverHeader>
            <PopoverBody>
                {props.target === 'Not-all-appointments' ?
                    <div>Not all appointments have a digital estimate. We are working diligently on expanding this offering. Estimates are generated up to 7 days in advance of your visit and available up to 90 days after your visit. For an estimate over the phone, please contact our Pre-Registration department at <a className="phone-link" href={`tel:${props.preRegPhone}`}>{props.preRegPhone}</a> or your physician’s office.</div>
                    : <div>{props.message}</div>}
            </PopoverBody>
        </Popover>
    </span>;
}
EstimatesMessage.propTypes = {
    target: PropTypes.string,
    message: PropTypes.any,
    preRegPhone: PropTypes.string
    
}
export default EstimatesMessage;